import type { IconComponent } from "@overmap-ai/blocks"
import { AssetStatusType } from "@overmap-ai/common"
import { amber, brown, gray, green, indigo, red } from "@radix-ui/colors"
import { Activity, CircleX, Minus, SquarePen, Trash, Wrench } from "lucide-react"

import { AssetMapColorMode, AssetTimelineItemType } from "../enums/assets"
import { modelIconMapping } from "./icons"

export const assetStatusTypeMapping: Record<AssetStatusType, { icon: IconComponent; label: string; color: string }> = {
	[AssetStatusType.PLANNED]: { icon: SquarePen, label: "Planned", color: indigo.indigo9 },
	[AssetStatusType.ACTIVE]: { icon: Activity, label: "Active", color: green.green9 },
	[AssetStatusType.MAINTENANCE]: { icon: Wrench, label: "Maintenance", color: amber.amber9 },
	[AssetStatusType.INACTIVE]: { icon: Minus, label: "Inactive", color: red.red9 },
	[AssetStatusType.RETIRED]: { icon: CircleX, label: "Retired", color: gray.gray9 },
	[AssetStatusType.DISPOSED]: { icon: Trash, label: "Disposed", color: brown.brown9 },
}

export const assetMapColorModeData: Record<AssetMapColorMode, { label: string; description: string }> = {
	[AssetMapColorMode.LAST_COMPLETED_STEP]: {
		label: "Last completed step",
		description: "Color reflects the last completed step",
	},
	[AssetMapColorMode.FIRST_INCOMPLETE_STEP]: {
		label: "First incomplete step",
		description: "Color reflects the first incomplete step",
	},
	[AssetMapColorMode.STATUS]: {
		label: "Status",
		description: "Color reflects the status of the asset",
	},
}

export const assetTimelineItemTypeData: Record<AssetTimelineItemType, { icon: IconComponent; label: string }> = {
	[AssetTimelineItemType.CREATED]: {
		icon: modelIconMapping.assetType,
		label: "Created",
	},
	[AssetTimelineItemType.ATTACHMENT]: {
		icon: modelIconMapping.attachment,
		label: "Attachments",
	},
	[AssetTimelineItemType.PROCEDURE]: {
		icon: modelIconMapping.procedureType,
		label: "Procedures",
	},
	[AssetTimelineItemType.FIELD_VALUES]: {
		icon: modelIconMapping.edit,
		label: "Field values",
	},
	[AssetTimelineItemType.COMMENT]: {
		icon: modelIconMapping.comment,
		label: "Comments",
	},
	[AssetTimelineItemType.ISSUE_ASSOCIATION]: {
		icon: modelIconMapping.issue,
		label: "Issues",
	},
	[AssetTimelineItemType.IDENTIFIER_VALUE]: {
		icon: modelIconMapping.identifier,
		label: "Identifiers",
	},
	[AssetTimelineItemType.FORM_SUBMISSION]: {
		icon: modelIconMapping.form,
		label: "Forms",
	},
}
